export const Button = {
    baseStyle: {
        fontWeight: "medium",
        borderRadius: "md",
        color: "white",
        border: "none",
        px: 6,
        py: 2,
        height: "auto",
        textTransform: "capitalize",
        _focus: {
            boxShadow: "none",
        },
        _focusVisible: {
            boxShadow: "none",
        },
    },
    variants: {
        transparent: {
            bgColor: "transparent",
            _hover: {
                _disabled: {},
            },
            _focus: {},
            _disabled: {},
        },
        outline: {
            bgColor: "transparent",
            border: "1px solid",
            borderColor: "neutral.300",
            _hover: {
                bgColor: "rgb(224, 244, 242, 0.1)",
                _disabled: {
                    bgColor: "transparent",
                },
            },
            _focus: {
                bgColor: "rgb(224, 244, 242, 0.1)",
            },
            _disabled: {
                bgColor: "transparent",
                cursor: "not-allowed",
            },
        },
        solid: {
            bgColor: "primary.300",
            color: "white",
            _hover: {
                bgColor: "primary.500",
                _disabled: {
                    bgColor: "neutral.200",
                },
            },
            _focus: {
                bgColor: "primary.500",
            },
            _disabled: {
                bgColor: "neutral.200",
                color: "neutral.600",
                cursor: "not-allowed",
                opacity: 1,
            },
        },
        ghost: {
            height: "auto",
            bgColor: "transparent",
            color: "primary.300",
            border: "none",
            p: 1,
            _hover: {
                color: "primary.700",
                bgColor: "transparent",
                _disabled: {
                    bgColor: "transparent",
                },
            },
            _focus: {
                color: "primary.700",
                bgColor: "transparent",
            },
            _active: {
                color: "primary.700",
                bgColor: "transparent",
            },
            _disabled: {
                color: "neutral.600",
                bgColor: "transparent",
                cursor: "not-allowed",
            },
        },
        dark: {
            bgColor: "neutral.850",
            color: "white",
            _hover: {
                bgColor: "rgb(224, 244, 242, 0.1)",
                _disabled: {
                    bgColor: "neutral.200",
                },
            },
            _focus: {
                bgColor: "rgb(224, 244, 242, 0.1)",
            },
            _disabled: {
                bgColor: "neutral.200",
                color: "neutral.600",
                cursor: "not-allowed",
                opacity: 1,
            },
        },
        error: {
            bgColor: "transparent",
            border: "1px solid",
            borderColor: "error",
            color: "error",
            _hover: {
                bgColor: "rgb(224, 244, 242, 0.1)",
                _disabled: {
                    bgColor: "transparent",
                },
            },
            _focus: {
                bgColor: "rgb(224, 244, 242, 0.1)",
            },
            _disabled: {
                bgColor: "transparent",
                cursor: "not-allowed",
            },
        },
        gradient: {
            bgGradient: 
            //"linear(to-r, rgba(0, 249, 216, 0.8), rgba(128, 137, 216, 0.64), rgba(133, 43, 250, 0.64))",
            "linear(to-b, rgba(250, 250, 251, 0.16) 0%, rgba(69, 191, 176, 0.159375) 0.01%, rgba(69, 191, 176, 0.04) 100%)",
            color: "#45BFB0",
            _hover: {
                bgColor: "primary.100",
                color: "#FFFFFF",
                _disabled: {
                    bgColor: "neutral.200",
                },
            },
            //_focus: {
            //  bgColor: "rgb(224, 244, 242, 0.1)",
            //},
            _disabled: {
                //bgColor: "neutral.200",
                //color: "white",
                //cursor: "not-allowed",
                opacity: 0.5,
            },
            borderColor: "#45BFB0",
            border: "1px solid",
        },
    },
    sizes: {
        sm: {
            h: "auto",
        },
        md: {
            h: "auto",
        },
    },
    defaultProps: {
        variant: "solid",
    },
};
